import React from "react";

function ThankYouForB() {
  return (
    <div
      style={{
        textAlign: "center",
        margin: "20px 0",
        fontFamily: "Lato, sans-serif",
        fontWeight: "bold",
        fontSize: "15 px",
      }}
    >
      ¡Gracias por elegirnos!
    </div>
  );
}

export default ThankYouForB;
